import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { useSnackbar } from "../../../utils/SnackbarContext"
import TranslatedText from "../../../utils/Translate"

export default function ApiServicesPermission() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    const [services, setServices] = useState([])
    const [partners, setPartners] = useState([])

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit API Service Permission` : 'Add API Service Permission'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };


    //Making request to get partners list
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Making request to get services list
    async function getServices(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/apiservices`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setServices(response.data)

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const getInitialApiServicePermission = () => ({
        partner: '',
        api_service: '',
    })

    const normalizeSelectValue = (value: unknown) => value === null || value === undefined ? '' : String(value)

    //Get user
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/apiservicesallowed/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    const permission = response.data[0]
                    setApiServicePermission({
                        ...getInitialApiServicePermission(),
                        ...permission,
                        partner: normalizeSelectValue(permission.partner),
                        api_service: normalizeSelectValue(permission.api_service),
                    })
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/apiservicesallowed`, {
                ...data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/apiservicesallowed/${id}`, {
                ...data,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    const [apiServicePermission, setApiServicePermission] = useState<any>(getInitialApiServicePermission())


    //On load if URL params contains type=edit
    useEffect(() => {
        getServices()
        getPartners()
        type === 'edit' && fetchData()
        console.log(apiServicePermission);

    }, [type])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 500, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} />*</InputLabel>
                        <Select sx={{ width: 500 }} labelId="simple-select-label" onChange={(e) => setApiServicePermission({ ...apiServicePermission, partner: e.target.value })} value={normalizeSelectValue(apiServicePermission.partner)} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                            <MenuItem value="">All</MenuItem>
                            {
                                partners.map((el: any) => {
                                    //make partners list item
                                    return (
                                        <MenuItem key={el.id} value={normalizeSelectValue(el.id)}>{el.partnerbankcode}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Channel'} />*</InputLabel>
                        <Select sx={{ width: 500 }} labelId="simple-select-label" onChange={(e) => setApiServicePermission({ ...apiServicePermission, api_service: e.target.value })} value={normalizeSelectValue(apiServicePermission.api_service)} variant="outlined" size="small" label={<TranslatedText text={'Channel'} />} >
                            {
                                services.map((el: any) => {
                                    //make services list item
                                    return (
                                        <MenuItem key={el.id} value={normalizeSelectValue(el.id)}>{el.name}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </Box>
                <Button onClick={() => type === "edit" ? putData(apiServicePermission) : postData(apiServicePermission)} variant="contained" sx={{ width: "100%" }}>Save</Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/apiservicespermissions' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        Saving error
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Successfully saved
                    </Alert>}
            </Snackbar>
        </Box >
    )
}